<template>
  <div class="concierge-option panels">
    <div class="panel-left-flex">
      <h3>Offsite Requirements</h3>
      <div class="form-section">
        <label>How many people are traveling?</label>
        <select v-model="pax">
          <option value="8-14">8-14 people</option>
          <option value="15-29">15-29 people</option>
          <option value="30-49">30-49 people</option>
          <option value="50+">50+ people</option>
        </select>
      </div>
      <div class="form-section">
        <label>Have you decided on a destination?</label>
        <div class="radioboxes">
          <div class="radiolabel" :class="{ on: destIsdecided === true }" @click="destIsdecided = true">
            <div class="radio" />
            <label>Yes</label>
          </div>
          <div class="radiolabel" :class="{ on: destIsdecided === false }" @click="destIsdecided = false">
            <div class="radio" />
            <label>No</label>
          </div>
        </div>
        <div v-if="destIsdecided">
          <label>Please tell us about the selected desintation?</label>
          <textarea v-model="destDetails" placeholder="What city exactly? Any other important details?" />
        </div>
      </div>
      <div class="form-section">
        <label>What bookings do you need?</label>
        <div class="checkboxes">
          <div class="checkboxlabel" :class="{ on: itemsIsFlights === true }" @click="itemsIsFlights = !itemsIsFlights">
            <div class="checkbox" />
            <label>Flights</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsHotels === true }" @click="itemsIsHotels = !itemsIsHotels">
            <div class="checkbox" />
            <label>Hotels</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsTransport === true }" @click="itemsIsTransport = !itemsIsTransport">
            <div class="checkbox" />
            <label>Transport</label>
          </div>
          <div class="checkboxlabel" :class="{ on: itemsIsOther === true }" @click="itemsIsOther = !itemsIsOther">
            <div class="checkbox" />
            <label>Other</label>
          </div>
        </div>
      </div>
      <div v-if="itemsIsFlights" class="form-section">
        <label>Flights: What are your dates, places and preferences?</label>
        <textarea v-model="detailsFlights" />
      </div>
      <div v-if="itemsIsHotels" class="form-section">
        <label>Hotels: What are your dates, places and preferences?</label>
        <textarea v-model="detailsHotels" />
      </div>
      <div v-if="itemsIsTransport" class="form-section">
        <label>Transport: What are your dates, places and preferences?</label>
        <textarea v-model="detailsTransport" />
      </div>
      <div v-if="itemsIsOther" class="form-section">
        <label>Other: What are your dates, places and preferences?</label>
        <textarea v-model="detailsOther" />
      </div>
      <button :disabled="isLoading" @click="submit">Create Trip Request</button>
    </div>
    <FAQ
      class="panel-right-40-percent"
      :faqs="[
        {
          question: 'How are company offsite trips different?',
          answer: 'Offsites typically start with a discussion about destination, which can be limited by group size and activity preferences.',
        },
        {
          question: 'What work do you do for offsite trips?',
          answer: 'We can handle absolutely everything for your offsite. We start with locking down a destination then do all the work to get everyone booked.',
        },
        {
          question: 'What happens next?',
          answer: 'Once you submit this form, we will allocate your request to the most suitable travel expert. They will reply within the hour.',
        },
      ]"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import Trip from "../classes/trip.js";
import FAQ from "../components/common/FaqPanel.vue";

const emit = defineEmits(["createTrip"]);

const isLoading = ref(false);
const pax = ref("8-14");

const destIsdecided = ref(true);
const destDetails = ref(null);
const dest = computed(() => {
  if (destIsdecided.value === true) {
    return destDetails.value;
  } else {
    return "Undecided";
  }
});

const itemsIsFlights = ref(true);
const itemsIsHotels = ref(true);
const itemsIsTransport = ref(false);
const itemsIsOther = ref(false);
const items = computed(() => {
  var req = [];
  if (itemsIsFlights.value) {
    req.push("Flights");
  }
  if (itemsIsHotels.value) {
    req.push("Hotels");
  }
  if (itemsIsTransport.value) {
    req.push("Transport");
  }
  if (itemsIsOther.value) {
    req.push("Other");
  }
  return req.join(", ");
});

const detailsFlights = ref(null);
const detailsHotels = ref(null);
const detailsTransport = ref(null);
const detailsOther = ref(null);
const details = computed(() => {
  var req = [];
  if (itemsIsFlights.value) {
    req.push("Details (Flights): " + (detailsFlights.value ? detailsFlights.value : "NA"));
  }
  if (itemsIsHotels.value) {
    req.push("Details (Hotels): " + (detailsHotels.value ? detailsHotels.value : "NA"));
  }
  if (itemsIsTransport.value) {
    req.push("Details (Transport): " + (detailsTransport.value ? detailsTransport.value : "NA"));
  }
  if (itemsIsOther.value) {
    req.push("Details (Other): " + (detailsOther.value ? detailsOther.value : "NA"));
  }
  return req.join("\n");
});

const description = computed(() => {
  var desc = "Concierge Offsite Trip - Offsite\n\n";
  desc += "Travelers: " + pax.value + "\n";
  desc += "Destination: " + dest.value + "\n";
  desc += "Required: " + items.value + "\n";
  desc += details.value;
  return desc;
});

const submit = () => {
  isLoading.value = true;
  const trip = new Trip();
  trip.description = description.value;
  trip.isSelfBook = false;
  emit("createTrip", trip);
};
</script>
